import { render } from "./LeaveView.vue?vue&type=template&id=70cffd13"
import script from "./LeaveView.vue?vue&type=script&lang=js"
export * from "./LeaveView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__